module.exports = __webpack_public_path__ + "sf-pro-text-semibold.svg?5082e194590b6a1103a4f6803df77a92";